module.exports = __webpack_public_path__ + "img/1545221759.ff37a17f.jpg";